import { ErrorBoundary, ModalComponent } from '@wkda/styleguide';
import { lazy, Suspense } from 'react';
import { useCarleadConflicts } from '../hooks/useCarleadConflicts/useCarleadConflicts';
import { jsx as _jsx } from "react/jsx-runtime";
const DuplicatedCarlead = /*#__PURE__*/lazy(() => {
  return import('./DuplicatedCarlead');
});
export function ModalCarleadCreationErrors() {
  const {
    error
  } = useCarleadConflicts();
  const ErrorComponent = error ? CARLEAD_ERROR_MODALS[error.type] : null;
  const isAvailable = !!ErrorComponent;
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(ModalComponent, {
      isOpen: isAvailable,
      focusTrapOptions: {
        fallbackFocus: '.btn'
      },
      children: isAvailable ? /*#__PURE__*/_jsx(Suspense, {
        fallback: null,
        children: /*#__PURE__*/_jsx(ErrorComponent, {})
      }) : null
    })
  });
}
const CARLEAD_ERROR_MODALS = {
  FIELD_ERRORS: null,
  NO_ERRORS: null,
  DUPLICATED_CARLEAD: DuplicatedCarlead
};